module.exports = __webpack_public_path__ + "img/person-login.d25a6cc8.gif";